import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';
import SearchBar from '../../searchBar/searchBar';



function CriarTurma() {
  const navigate = useNavigate();

  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/turma')

  const handleSubmit = async (values) => {
    console.log(formValue);
    
    values.preventDefault();
    util.isSubmitting()
    const result = await api.registrarTurmaApi(formValue);
    result ? toast.success("Criado com sucesso!") && navigate("/area-turma") : null;
    util.isSubmitting()
    
  }



  const [formValue, setFormValue] = useState({
    nomeTurma: '',
    codTurma: '',
    idFilial: userLogin.idfilial,
    nomeFilial: userLogin.nomefilial,
    idEscola: userLogin.idescola,
    login: '',
    senha: ''
  });
  
  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
      height:"100vh", minHeight:'500px',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column align-items-center'>

          <MDBCard className='bg-dark text-white h-75 w-75' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-5'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={handleSubmit}>
                  <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite o nome da turma!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='Nome da turma' id='formControNomeTurma' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='nomeTurma'
                          value={formValue.nomeTurma || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite o código da turma!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='CodTurma' 
                          name='codTurma' 
                          id='formControCodTurma' 
                          type='text' 
                          size="lg"
                          value={formValue.codTurma || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          style={{color:"white"}}/>
                      </MDBValidationItem >
                    </div>
                    
                    <div className='d-flex flex-row justify-content-between'>
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite seu login!' invalid>
                        <MDBInput 
                          wrapperClass='w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='Login'  
                          name='login'
                          id='formControLogin' 
                          type='text' 
                          size="lg"
                          value={formValue.login || ''}
                          onChange={onChange}
                          required
                          style={{color:"white"}}/>
                          
                        
                      
                      </MDBValidationItem >
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite uma senha válida!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='Senha' id='formControSenha' 
                          type='password' 
                          size="lg" 
                          style={{color:"white"}}
                          name='senha'
                          value={formValue.senha || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          minLength={3}
                          
                          />
                      
                      </MDBValidationItem>
                      </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 btn-home' 
                        color='white' 
                        size='lg'
                        type='submit'   
                        id='submitForm'  
                        //disabled={formValue.senha.length < 3 || formValue.nomeAdministrador.length < 1 || formValue.login.length < 1}                 
                        >
                        
                        Registrar
                      </MDBBtn>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/area-turma")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default CriarTurma;